import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { transition, style, animate, trigger } from '@angular/animations';
import { ViewService } from 'src/app/view/view.service';
import { Store, Select } from '@ngxs/store';
import { ViewState } from 'src/app/view/state/view.state';
import { Subject, Observable, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LayoutService } from 'src/app/view/layout.service';
import { ViewLayout } from 'src/app/view/models/view-layout.enum';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewLayoutModel } from 'src/app/view/models/view-layout.model';

@Component({
  selector: 'app-view-column-container',
  templateUrl: './view-column-container.component.html',
  styleUrls: ['./view-column-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ 
          transform: 'translateX(-320px)'
        }),
        animate('300ms ease-in-out', style({ 
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ 
          transform: 'translateX(-320px)'
        }))
      ])
    ])
  ]

})
export class ViewColumnContainerComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  @Select(ViewState.getLayout)
  layout$: Observable<ViewLayoutModel>;



  // ---------- Class Variables ----------
  ngUnsubscribe = new Subject();
  viewLayout = ViewLayout;
  application = EnvironmentApplication;
  

  
  // ---------- Lifecycle Events ----------
  constructor(
    private viewService: ViewService,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initLayoutObserver();
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  
  
  // ---------- Layout ----------
  initLayoutObserver() {
    combineLatest(
      this.layout$,
      this.chapter$
    )
    .pipe(
      takeUntil(this.ngUnsubscribe)
    )
    .subscribe(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  isVisible(viewLayout: ViewLayout) {
    switch (viewLayout) {
      case ViewLayout.Column:
        return this.layoutService.isColumnVisible();
      case ViewLayout.NodeInfo:
        return this.layoutService.isNodeInfoVisible('column');
      case ViewLayout.Search:
        return this.layoutService.isSearchColumnVisible();
    }
  }

  handleSearchClick() {
    this.viewService.toggleSearch(true);
  }
}
